import { render, staticRenderFns } from "./notif.vue?vue&type=template&id=72dafb39"
import script from "./notif.vue?vue&type=script&lang=js"
export * from "./notif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports